import {GET_SSHKEYS,ADD_SSHKEY,DELETE_SSHKEY,SSHKEY_ERROR,CLEAR_ERRORS,SELECT_KEY,CANCEL_KEY} from './sshkeyTypes';

const initialState = {
  keys: null,
  error: null,
  keyToDelete: null
};

export default (state=initialState, action) => {
  switch(action.type){
    case GET_SSHKEYS:
      return {
        ...state,
        keys: action.payload
      };
    case ADD_SSHKEY:
      return {
        ...state,
        keys: [...state.keys, action.payload]
      };
    case DELETE_SSHKEY:
      return {
        ...state,
        keys: state.keys.filter(v=>v!==action.payload)
      };
    case SSHKEY_ERROR:
      return {
        ...state,
        error: action.payload
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null
      };
    case SELECT_KEY:
      return {
        ...state,
        keyToDelete: action.payload
      };
    case CANCEL_KEY:
      return {
        ...state,
        keyToDelete: null
      };
    default:
      return {...state}
  }
}

